module.exports = __webpack_public_path__ + "static/media/users_unselected.d13db499.svg";